import React, { Component } from 'react';
import { Switch } from 'antd';

import withFieldWrapper from 'components/hocs/withFieldWrapper';

@withFieldWrapper
export default class SwitchComponent extends Component {
    render() {
        const { input, ...params } = this.props;

        return (
            <Switch
                {...params}
                checked={input.value || null}
            />
        );
    }
}
